import { render } from "./ShopCafe.vue?vue&type=template&id=50136434&scoped=true"
import script from "./ShopCafe.vue?vue&type=script&lang=js"
export * from "./ShopCafe.vue?vue&type=script&lang=js"

import "./ShopCafe.vue?vue&type=style&index=0&id=50136434&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50136434"]])

export default __exports__